var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceHasNoiseRestrictions(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85519 19.482H5.75031V21.357H3.85519V19.482Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53438 19.482H9.42956V21.357H7.53438V19.482Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.5168V28.7097H3.86525V32.5H28.1348V28.7096H32V15.5168H0ZM26.2598 30.625H5.74025V25.4948H7.51337V28.405H9.38838V25.4948H11.3038V28.405H13.1788V25.4948H15.0941V28.405H16.9691V25.4948H18.8845V28.405H20.7595V25.4948H22.6749V28.405H24.5499V25.4948H26.2598L26.2598 30.625ZM30.125 26.8346H28.1348V23.6197H3.86525V26.8346H1.875V17.3918H30.125V26.8346Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1964 0.5C17.9159 0.5 16.7701 1.08713 16.0138 2.00619C15.2574 1.08713 14.1116 0.5 12.8312 0.5H5V13.5522H27V0.5H19.1964ZM19.1964 2.375H25.125V7.83712H19.1964C18.3691 7.83712 17.5981 8.08213 16.9519 8.5035V4.62069C16.9519 4.61263 16.9513 4.60469 16.9513 4.59662C16.9643 3.36944 17.9661 2.375 19.1964 2.375ZM6.875 2.375H12.8312C14.0614 2.375 15.0633 3.36944 15.0763 4.59662C15.0762 4.60469 15.0756 4.61263 15.0756 4.62069V8.50344C14.4294 8.08212 13.6584 7.83712 12.8312 7.83712H6.875V2.375ZM6.875 9.71212H12.8312C13.9744 9.71212 14.9201 10.571 15.0587 11.6772H6.875V9.71212ZM25.125 11.6772H16.9688C17.1074 10.5709 18.0531 9.71212 19.1963 9.71212H25.125V11.6772Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceHasNoiseRestrictions);
export default __webpack_public_path__ + "static/media/spaceHasNoiseRestrictions.2325a546b115baa8f40a37a76f95f236.svg";
export { ForwardRef as ReactComponent };